export default {"src":"/pro/_next/static/media/blitz-monochrome-icon.bb3a9316.svg","height":16,"width":15,"blurWidth":0,"blurHeight":0};